export default {
    cs: {
        Offers:"Pro vás",
        Projects:"O nás",
        Contact:"Kontakt"
    },
    en: {
        Offers:"For you"
    }
}